<template>
  <div>
    <b-row
      class="d-flex align-items-end"
      v-for="(item, index) in model"
      :key="index"
    >
      <b-col cols="11">
        <b-button
          v-b-toggle="`collapse-${index}`"
          size="lg"
          class="btn btn-block text-left mt-3 collapse-no-margin shadow"
          >ข้อมูลโครงการ {{ index + 1 }}</b-button
        >
        <b-collapse :id="`collapse-${index}`">
          <div class="card shadow card-plant">
            <div class="card-body">
              <b-row>
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >ชื่อโครงการ :</b-col
                >
                <b-col class="text-left" md="8" cols="12">
                  <b-form-input
                    class="input_text border-orange"
                    v-model="item.name"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >ที่อยู่ :</b-col
                >
                <b-col class="text-left" md="8" cols="12">
                  <b-form-input
                    class="input_text border-orange"
                    v-model="item.address"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >ทรัพยากร :</b-col
                >
                <b-col class="text-left" md="8" cols="12">
                  <b-form-input
                    class="input_text border-orange"
                    v-model="item.resource"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >ความร่วมมือ :</b-col
                >
                <b-col class="text-left" md="8" cols="12">
                  <textarea
                    v-model="item.coordinate"
                    class="px-4 input_text w-100"
                    rows="5"
                  ></textarea>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >กิจกรรม :</b-col
                >
                <b-col class="text-left" md="8" cols="12">
                  <textarea
                    v-model="item.event"
                    class="px-4 input_text w-100"
                    rows="5"
                  ></textarea>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >พื้นที่เก็บรักษา :</b-col
                >
                <b-col class="text-left" md="8" cols="12">
                  <b-form-input
                    class="input_text border-orange"
                    v-model="item.storage_area"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >งบประมาณ :</b-col
                >
                <b-col class="text-left" md="4" cols="12">
                  <b-form-input
                    class="input_text border-orange text-right"
                    v-model="item.budget"
                    type="number"
                  ></b-form-input>
                </b-col>
                <b-col class="text-left" md="3" cols="12">บาท</b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >ระยะเวลา :</b-col
                >
                <b-col class="text-left" md="4" cols="12">
                  <b-form-input
                    class="input_text border-orange text-right"
                    v-model="item.duration"
                    type="number"
                  ></b-form-input>
                </b-col>
                <b-col class="text-left" md="3" cols="12">เดือน</b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >ผู้ประสานงาน :</b-col
                >
                <b-col class="text-left" md="8" cols="12">
                  <b-form-input
                    class="input_text border-orange"
                    v-model="item.coordinator"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >เบอร์โทร :</b-col
                >
                <b-col class="text-left" md="4" cols="12">
                  <b-form-input
                    class="input_text border-orange"
                    v-model="item.phone_number"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >บันทึกข้อตกลง :</b-col
                >
                <b-col class="text-left" md="4" cols="12">
                  <b-form-input
                    class="input_text border-orange"
                    v-model="item.memorandum"
                    type="text"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="text-md-right text-left" md="3" cols="12"
                  >แนบไฟล์ :</b-col
                >
                <b-col class="text-left" md="6" cols="12">
                  <b-form-input
                    v-model="item.file_name"
                    class="input_text"
                    type="text"
                  ></b-form-input>
                </b-col>
                <b-col class="text-md-right text-left" md="2" cols="12">
                  <label
                    class="btn shadow orange-background pill"
                    :for="`upload${index}`"
                  >
                    อัพโหลด
                  </label>
                  <input
                    @change="uploadFile($event, index)"
                    :id="`upload${index}`"
                    style="visibility: hidden"
                    type="file"
                    accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
text/plain, application/pdf"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-collapse>
      </b-col>
      <b-col cols="1">
        <div class="d-flex">
          <b-icon
            v-if="model.length != 1"
            @click="removeTemplate(index)"
            class="mr-3 pointer"
            icon="dash-circle"
          ></b-icon>
          <b-icon
            v-if="index + 1 === model.length"
            @click="addTemplate()"
            class="text-danger pointer"
            icon="plus-circle"
          ></b-icon>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3 justify-content-end mb-5">
      <b-col md="2">
        <b-button class="btn btn-block shadow none-background" pill
          >ยกเลิก</b-button
        ></b-col
      >
      <b-col md="3">
        <b-button
          @click="save"
          class="btn btn-block shadow green-background"
          pill
          >บันทึก</b-button
        ></b-col
      >
    </b-row>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { domain } from "@/utils/Constants";
import axios from "axios";
import { mapState } from "vuex";
export default {
  data() {
    return {
      model: [
        {
          name: null,
          address: null,
          resource: null,
          coordinate: null,
          event: null,
          storage_area: null,
          budget: null,
          duration: null,
          coordinator: null,
          phone_number: null,
          memorandum: null,
          attached_file: null,
          community_id: null,
          file_name: null,
        },
      ],
    };
  },
  props: {
    community: {
      default: function () {
        return [
          {
            name: null,
            address: null,
            resource: null,
            coordinate: null,
            event: null,
            storage_area: null,
            budget: null,
            duration: null,
            coordinator: null,
            phone_number: null,
            memorandum: null,
            attached_file: null,
            community_id: null,
            file_name: null,
          },
        ];
      },
    },
  },
  computed: {
    ...mapState({
      selectComunity: (state) => state.communityModule.select_comunity,
    }),
  },
  watch: {
    community: function (newVal, oldVal) {
      this.defineToModel(newVal);
    },
  },
  created() {
    this.defineToModel(this.community);
  },
  methods: {
    addTemplate() {
      this.model.push({
        name: null,
        address: null,
        resource: null,
        coordinate: null,
        event: null,
        storage_area: null,
        budget: null,
        duration: null,
        coordinator: null,
        phone_number: null,
        memorandum: null,
        attached_file: null,
        community_id: null,
        file_name: null,
      });
    },
    defineToModel(model) {
      this.model =
        model.length > 0
          ? model
          : [
              {
                name: null,
                address: null,
                resource: null,
                coordinate: null,
                event: null,
                storage_area: null,
                budget: null,
                duration: null,
                coordinator: null,
                phone_number: null,
                memorandum: null,
                attached_file: null,
                community_id: null,
                file_name: null,
              },
            ];
      this.model.forEach((x) => {
        x.file_name = x.attached_file
          ? x.attached_file.replace(/^.*[\\\/]/, "")
          : null;
      });
    },
    removeTemplate(index) {
      this.model.splice(index, 1);
    },
    uploadFile(event, index) {
      if (event.target.files.length > 0) {
        let image = event.target.files[0];
        var formData = new FormData();
        formData.append("file", image);
        formData.append("token", this.accessToken);
        axios({
          method: "post",
          url: domain + "/api/uploadFile",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          this.model[index].attached_file = res.data.result;
          this.model[index].file_name = res.data.result.replace(
            /^.*[\\\/]/,
            ""
          );
        });
      }
    },
    save() {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch("communityModule/onStoreCommunityProject", {
              project: this.model,
              community_id: this.selectComunity.community_id,
            })
            .then((res) => {
              if (res == 200) {
                Swal.hideLoading();
                this.$emit("onRefresh");
              }else{
                Swal.clickConfirm();
              }
            });
        },
      });
    },
  },
};
</script>

<style>
</style>